import type { OverviewRow } from "./hooks";
import { formatDateTime } from "./utils";

type OverviewTableProps = {
  rows: OverviewRow[];
  selectedTracking: string | null;
  onSelect: (trackingNumber: string) => void;
  isLoading: boolean;
};

export function BlulogOverviewTable({ rows, selectedTracking, onSelect, isLoading }: OverviewTableProps) {
  return (
    <section className="blulog-overview">
      <header>
        <h2>Table des suivis</h2>
        <span className="blulog-count">Nombre de lignes : {rows.length}</span>
      </header>

      <div className="blulog-table-wrapper">
        <table className="blulog-table">
          <thead>
            <tr>
              <th>Id1 / Id2</th>
              <th>Première mesure</th>
              <th>Dernière mesure</th>
              <th>Numéro de suivi</th>
              <th>Organisation</th>
              <th>Lieu du scan</th>
              <th>Article EI</th>
              <th>Expé.</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => {
              const isActive = row.trackingNumber === selectedTracking;
              return (
                <tr
                  key={row.trackingNumber}
                  className={isActive ? "is-active" : ""}
                  onClick={() => onSelect(row.trackingNumber)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      onSelect(row.trackingNumber);
                    }
                  }}
                  tabIndex={0}
                  role="button"
                >
                  <td>
                    <span>{row.id1 || "—"}</span>
                    <br />
                    <span>{row.id2 || "—"}</span>
                  </td>
                  <td>{formatDateTime(row.firstMeasure)}</td>
                  <td>{formatDateTime(row.lastMeasure)}</td>
                  <td>{row.trackingNumber}</td>
                  <td>{row.organisation}</td>
                  <td>{row.scanLocation || "—"}</td>
                  <td>{row.articleEi || "—"}</td>
                  <td>{row.expeditionCount}</td>
                </tr>
              );
            })}
            {rows.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: "center", padding: "1rem" }}>
                  {isLoading ? "Chargement des données…" : "Aucune donnée disponible."}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </section>
  );
}
